// extracted by mini-css-extract-plugin
module.exports = {"services":"styles-module--services--3R0Gw","title":"styles-module--title--3ewab","text":"styles-module--text--3AWvP"};